import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Alert, AlertContainer, Icon } from '@salesforce/design-system-react';

import './DataResidencyBanner.scss';

function DataResidencyBanner({ children, classNames }) {
  return (
    <div className={classnames('mce-data-residency-banner', classNames)}>
      <AlertContainer>
        <Alert
          icon={<Icon category="utility" name="announcement" />}
          labels={{
            heading: children
          }}
        />
      </AlertContainer>
    </div>
  );
}

DataResidencyBanner.displayName = 'DataResidencyBanner';
DataResidencyBanner.propTypes = {
  children: PropTypes.node.isRequired,
  classNames: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};

export default DataResidencyBanner;
